module.exports = __webpack_public_path__ + "static/media/plaza.4c14e3e0.png";